import { render, staticRenderFns } from "./PageHeaderInstitution.vue?vue&type=template&id=ca7cb592&scoped=true"
import script from "./PageHeaderInstitution.vue?vue&type=script&lang=js"
export * from "./PageHeaderInstitution.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderInstitution.vue?vue&type=style&index=0&id=ca7cb592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7cb592",
  null
  
)

export default component.exports